import React, { FC, useState } from 'react';
import { Button, Dropdown, Menu, Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import { Beneficiary } from '~/types';
import { EllipsisVerticalIcon } from '~/img';
import DeleteAction from './DeleteAction';
import BeneficiaryEdit from '../BeneficiaryEdit';
import { usePermissions } from '~/hooks';

interface Props {
  beneficiary: Beneficiary;
}

const BeneficiaryActions: FC<Props> = (props) => {
  const { beneficiary } = props;
  const [t] = useTranslation();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const hasAccessUpdate = false; // usePermissions('business.beneficiary.update');
  const hasAccessDelete = usePermissions('business.beneficiary.delete');

  if (!hasAccessDelete && !hasAccessUpdate) return null;
  return (
    // eslint-disable-next-line
    <div role="menu" onClick={(e: any) => e.stopPropagation()}>
      <Dropdown
        trigger={['click']}
        overlay={
          <Menu>
            {hasAccessUpdate && (
              <Menu.Item key="edit" onClick={handleOpen}>
                <Typography.Text>
                  <EditOutlined />
                  {t('edit')}
                </Typography.Text>
              </Menu.Item>
            )}
            {hasAccessDelete && <DeleteAction beneficiary={beneficiary} />}
          </Menu>
        }
      >
        <Button
          icon={<EllipsisVerticalIcon />}
          type="text"
          shape="circle"
          className="PayoutsCollapse-OptionsButton"
        />
      </Dropdown>
      <BeneficiaryEdit open={open} onClose={handleClose} beneficiary={beneficiary} />
    </div>
  );
};

export default BeneficiaryActions;
